import React, { useState } from 'react';
import Card from '../UI/Card';
import Button from '../UI/Button';
import classes from './Landing.module.css';
import Modal from '../UI/Modal';

const Landing = () => {
  const [url, setUrl] = useState('');
  const [shortUrl, setShortUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({
    isError: false,
    errorMessage: 'Sample Error Message',
  });

  const removeErrorModal = () => {
    // Used setTimeout here bcoz the modal overlay takes 500ms to go out of the screen,
    // so the Modal component should be visible until 500ms after clicking cool, so that
    // looks good
    setTimeout(() => {
      setError((prevError) => {
        return {
          isError: !prevError.isError,
          errorMessage: prevError.errorMessage,
        };
      });
    }, 500);
  };

  const addErrorModal = (message) => {
    setError((prevError) => {
      return {
        isError: !prevError.isError,
        errorMessage: message,
      };
    });
  };

  const urlChangeHandler = (e) => {
    setUrl(e.target.value);
  };

  const submitHandler = (e) => {
    e.preventDefault();

    if (url.length === 0) {
      addErrorModal('Enter URL to be shortened!');
      return;
    }

    if (!url.includes('https://')) {
      addErrorModal('Enter a valid URL! (missing https://)');
      return;
    }

    setIsLoading(true);
    fetch('https://anls.herokuapp.com/', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ url: `${url}` }),
    })
      .then((res) => {
        console.log(res);
        if (res.status === 404) {
          console.log('404 status');
          throw new Error('No URL provided');
        }
        setIsLoading(false);
        return res.json();
      })
      .then((data) => {
        setShortUrl(`https://anls.herokuapp.com/${data.shorturl}`);
        console.log(data);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const onCopy = (e) => {
    navigator.clipboard.writeText(shortUrl);
  };

  return (
    <div className={classes.container}>
      <Card>
        <form className={classes.form} onSubmit={submitHandler}>
          <input
            onChange={urlChangeHandler}
            type="text"
            placeholder="Enter URL"
          />
          <Button type="submit">Shorten</Button>
        </form>
        <div className={classes.loading}>{isLoading && <p>Loading...</p>}</div>
        <ul>
          <li>
            <span className={classes.shorturl}>{shortUrl}</span>
            <Button onClick={onCopy}>Copy</Button>
          </li>
        </ul>
      </Card>
      {error.isError && (
        <Modal onClick={removeErrorModal} msg={error.errorMessage} />
      )}
    </div>
  );
};

export default Landing;
